import type { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Fade";
import { useTranslation } from "@privacy/translations";
import { CircularProgress } from "@privacy/ui";
import { AlertCircleIcon, TriangleAlertIcon } from "../../shared/icons";

type ErrorMessageProps = {
  /** If no errorMessage is passed as prop we fallback to generic message */
  errorMessage?: string;
  variant?: "error" | "warning" | "loading";
};

export const ErrorMessage: FC<ErrorMessageProps> = ({ errorMessage, variant = "error" }) => {
  const { t } = useTranslation();
  const Icon = variant === "warning" ? TriangleAlertIcon : AlertCircleIcon;

  return (
    <Fade in unmountOnExit>
      <Typography
        sx={{
          ml: 2,
          mt: 1,
          fontSize: theme => theme.typography.pxToRem(12),
          color: theme => theme.palette[variant === "loading" ? "info" : variant].main,
        }}
      >
        <Box component="span" sx={{ display: "inline-flex", verticalAlign: "-1px", mr: "3px" }}>
          {variant === "loading" ? <CircularProgress size={12} thickness={5} color="inherit" /> : <Icon size={12} />}
        </Box>
        {errorMessage ? errorMessage : t("DynamicForm.Inline.FailedToSave")}
      </Typography>
    </Fade>
  );
};
